export const lotPermissions = {
    SIZING: {
        EDIT: {
            key: 'SiteSizing.Edit',
            name: 'Site sizing configuration',
            description: 'Add, edit and delete site sizing configuration'
        }
    },
    ACCESS: {
        OPEN_GATE: {
            key: 'Lot.Access.OpenGate',
            name: 'Open lot gate',
            description: 'Unlock a lot gate from within Parq'
        }
    },
    DELETE: {
        key: 'Lot.Delete',
        name: 'Delete lot',
    },
    // SCN-633 -- keys must match PMF.Application.Common.Authorize.Constants.Permissions.Lot
    // (parqai-api) EXACTLY: 'Lot.Close' / 'Lot.Deprecate'. No role has been granted either
    // permission yet (11-open-decisions.md Decision 12 is still open), so these have no
    // effect today -- they exist so the moment a grant is added, the matching
    // EDIT_PERMISSION check in lotPermissionProfile.js picks it up for any role without a
    // second Web PR, not just the provisional OWNER/ADMIN role check.
    CLOSE: {
        key: 'Lot.Close',
        name: 'Close lot',
    },
    DEPRECATE: {
        key: 'Lot.Deprecate',
        name: 'Mark lot as deprecated',
    },
    IMPORT:{
        key: 'Lot.Import',
        name: 'Allow importing lot',
    },
    CAPACITY:{
        key: 'Lots.Capacity',
        name: 'Lot Capacity Page',
    },
    VIEW_DSP_FIELD: {
        key: 'lots.view.dsp',
        name: 'View DSP Field',
    }
}